import { HowItWorks } from './view';

export default HowItWorks;
